import { forwardRef, memo } from 'react';
import { Text } from '../text';
import { StyledCounter } from './counter.styled';
import { CounterProps } from './counter.types';

export const Counter = memo(
  forwardRef<HTMLSpanElement, CounterProps>(
    (
      {
        size = 'm',
        variant = 'main',
        color = 'primary',
        count = 0,
        overflowCount = 99,
        isDot = false,
        ...restProps
      },
      forwardedRef
    ) => {
      if (count < 0) {
        return null;
      }

      return (
        <StyledCounter
          ref={forwardedRef}
          $size={size}
          $variant={variant}
          $color={color}
          $isDot={isDot}
          {...restProps}
        >
          {!isDot && (
            <Text variant={size === 's' ? 'caption-11' : 'caption-13'}>
              {count > overflowCount ? `${overflowCount}+` : count}
            </Text>
          )}
        </StyledCounter>
      );
    }
  )
);
